module.exports = __webpack_public_path__ + "img/w3c.5f783a50.png";